import { ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout/models';

import { getComponentProps } from '@gn-audio/jss-core';

import { useHeaderNavigation } from '../../components';

export const useComponentProps = (componentName: string): ComponentRendering | null => {
  const { route } = useHeaderNavigation();

  return (route && getComponentProps(route.placeholders, componentName)) || null;
};
